export default "__VITE_ASSET__BBcHc2Fw__"